import type { TOC } from '@ember/component/template-only';
import { on } from '@ember/modifier';
import svgJar from 'ember-svg-jar/helpers/svg-jar';
import EmberTooltip from 'ember-tooltips/components/ember-tooltip';

interface SensitiveRevealToggleSignature {
  Args: {
    revealed: boolean;
    onToggle: () => void;
  };
  Element: HTMLButtonElement;
}

/**
 * The eye button that reveals/hides a masked sensitive field's value. Layout is
 * the caller's responsibility: pass positioning via `class` (e.g. in-input
 * `absolute top-1/2 -translate-y-1/2 right-2`, or inline in a label) — it merges
 * onto the base via `...attributes`.
 */
export default <template>
  <button
    type="button"
    class="inline-flex items-center align-middle text-carbon-50"
    aria-label={{if @revealed "Hide sensitive field" "Show sensitive field"}}
    aria-pressed={{if @revealed "true" "false"}}
    data-test-sensitive-reveal-toggle
    {{on "click" @onToggle}}
    ...attributes
  >
    {{svgJar
      (if @revealed "sensitive-eye-slashed" "open-eye-grayLight")
      width="14"
      height="14"
      class="[&_path]:fill-current [&_circle]:fill-current"
    }}
    <EmberTooltip @side="top" @delay={{200}} @popperContainer="body">
      {{if @revealed "Hide sensitive field" "Show sensitive field"}}
    </EmberTooltip>
  </button>
</template> satisfies TOC<SensitiveRevealToggleSignature>;
